export const MOBILE = 500;